/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legal_Travel_NameInputs */

const en_service_legal_travel_name = /** @type {(inputs: Service_Legal_Travel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Travel Assistance`)
};

const fr_service_legal_travel_name = /** @type {(inputs: Service_Legal_Travel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance juridique en voyage`)
};

/**
* | output |
* | --- |
* | "Legal Travel Assistance" |
*
* @param {Service_Legal_Travel_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legal_travel_name = /** @type {((inputs?: Service_Legal_Travel_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legal_Travel_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legal_travel_name(inputs)
	return fr_service_legal_travel_name(inputs)
});